module.exports = __webpack_public_path__ + "static/dash-1-2d5b96a309a050a1d0423e793ed04ef1.png";